import React from 'react';
import styles from './index.module.css';

export const Input = React.forwardRef((
  { 
    children, 
    id, 
    type, 
    value, 
    label,
    required,
    ...props 
  }, ref) => {

    return (
      <div className={styles.input}>
        {label && (
          <label htmlFor={id} className={styles.label}>
            {label}{required && <span className={styles.required}>*</span>}
          </label>
        )}
        <input id={id} type={type} value={value} ref={ref} className={styles.field} {...props}/>
      </div>
    )
  }
);